var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { getUiOptions } from "../utils/";

var defaultProps = {
    defaultFormData: {
        "placeId": undefined,
        "lat": undefined,
        "lng": undefined,
        "alt": undefined
    },
    defaultOptions: {},
    defaultSchema: {
        type: "object",
        properties: {
            placeId: {
                type: "string"
            },
            lat: {
                type: "number"
            },
            lng: {
                type: "number"
            },
            alt: {
                type: "number"
            }
        }
    }
};

var getSchema = function getSchema(props) {
    var schema = props.schema,
        defaultSchema = props.defaultSchema;

    var properties = schema && schema.properties;

    var fieldSchema = defaultSchema;

    if (properties) {

        fieldSchema = _extends({}, fieldSchema, {
            properties: _extends({}, fieldSchema.properties, properties)
        });
    }

    return fieldSchema;
};

function getUiSchema(props) {
    var schema = props.schema,
        uiSchema = props.uiSchema,
        defaultOptions = props.defaultOptions;


    var options = getUiOptions(uiSchema);

    return {
        "ui:options": _extends({}, defaultOptions, options)
    };
}

function getFormData(props) {
    var formData = props.formData,
        defaultFormData = props.defaultFormData;


    formData = _extends({}, defaultFormData, formData);

    return formData;
}

export default function getField(props) {

    props = _extends({}, defaultProps, props);

    var schema = getSchema(props);
    var uiSchema = getUiSchema(_extends({}, props, { schema: schema }));
    var formData = getFormData(_extends({}, props, { schema: schema, uiSchema: uiSchema }));

    return _extends({}, props, {
        schema: schema,
        uiSchema: uiSchema,
        formData: formData
    });
}